(() => {
  if (customElements.get('dmr-product-reviews')) return;
  class DmrProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('[data-dmr-reviews-track]');
      const move = direction => track.scrollBy({left: direction * Math.max(220, track.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      const navigation = () => {
        this.querySelector('[data-dmr-review-step="-1"]').disabled = track.scrollLeft < 4;
        this.querySelector('[data-dmr-review-step="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      track.addEventListener('scroll', navigation, {passive:true, signal});
      window.addEventListener('resize', navigation, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }, {signal});
      navigation();
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-dmr-review-step]');
        if (step) { move(Number(step.dataset.dmrReviewStep)); return; }
        const link = event.target.closest('[data-dmr-review-id]');
        if (!link || !link.dataset.dmrReviewId || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (typeof window.LOOX?.openQV !== 'function') return;
        try {
          window.LOOX.openQV(link.dataset.dmrReviewId, null, document.documentElement.lang);
          event.preventDefault();
          document.querySelectorAll('video').forEach(video => video.pause());
        } catch (_) {}
      }, { signal });
      const details = this.querySelector('[data-dmr-reviews-all]');
      if (!details) return;
      const reveal = () => {
        if (!location.hash) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
        if (target && details.contains(target)) {
          details.open = true;
          requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
        }
      };
      window.addEventListener('hashchange', reveal, { signal });
      reveal();
      details.addEventListener('toggle', () => {
        if (details.open) window.dispatchEvent(new Event('resize'));
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('dmr-product-reviews', DmrProductReviews);
})();
